import "../../../styles.css";
import React from "react";
import Lottie from "react-lottie-player";
import animationData from "../../../Assets/svgs/404.json";
const PageNotFound = () => {
  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Lottie
          loop
          animationData={animationData}
          play
          style={{
            width: "auto",
            height: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        />
      </div>
    </>
  );
};

export default PageNotFound;
